import {
  DomainTreeNodeType,
  type DomainTree,
  type DomainTreeNode,
  type FilterItem,
} from '@terra/ui-design-system';
import { decodeUriComponentSafely } from '@terra/shared-utils';

const collectDomainNodes = (nodes: DomainTreeNode[]): DomainTreeNode[] =>
  nodes.flatMap((node) => {
    if (node.nodeType === DomainTreeNodeType.AppLevel) {
      return collectDomainNodes(node.children);
    }

    return node.nodeType === DomainTreeNodeType.Domain ? [node] : [];
  });

export const resolveAssetsPathNodeLabel = (node: DomainTreeNode): string =>
  node.fullPath
    ? `${node.fullDomain}${decodeUriComponentSafely(node.fullPath)}`
    : node.fullDomain;

export const buildAssetsPathFilterItems = (
  domainTree: DomainTree | null | undefined,
): FilterItem[] =>
  collectDomainNodes(domainTree?.roots ?? []).map((domainNode) => {
    const pathChildren = domainNode.children
      .filter((child) => child.nodeType === DomainTreeNodeType.Path)
      .map((pathNode) => ({
        value: pathNode.id,
        label: pathNode.fullPath
          ? decodeUriComponentSafely(pathNode.fullPath)
          : pathNode.name,
      }));

    return {
      value: domainNode.id,
      label: domainNode.fullDomain,
      ...(pathChildren.length > 0 ? { children: pathChildren } : {}),
    };
  });
